import React from "react";
import { Check, ArrowRight } from "lucide-react";

export default function GroupCircles({ bullets = [], image, onBook }) {
  return (
    <section className="py-16 md:py-24" style={{ background: "var(--ev-bg-2)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center">
        <div className="order-2 md:order-1">
          <h2 className="font-serif-ev text-4xl sm:text-5xl md:text-[3.25rem] leading-[1.05] tracking-tight">
            Group Circles & Workshops
          </h2>
          <p className="mt-5 text-[15px] md:text-base max-w-lg" style={{ color: "var(--ev-muted)" }}>
            Heal and manifest alongside a warm community, live over Zoom — the accountability and belonging
            that keeps you consistent.
          </p>
          <ul className="mt-8 space-y-4">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="mt-0.5 w-6 h-6 rounded-full grid place-items-center flex-shrink-0" style={{ background: "var(--ev-blue-2)" }}>
                  <Check className="w-3.5 h-3.5 text-white" />
                </span>
                <span className="text-[15px] md:text-base" style={{ color: "var(--ev-ink-2)" }}>{b}</span>
              </li>
            ))}
          </ul>
          {onBook && (
            <button data-testid="group-circles-book-btn" onClick={onBook} className="mt-8 ev-btn ev-btn-primary">
              Book a free session <ArrowRight className="w-4 h-4" />
            </button>
          )}
        </div>
        <div className="ev-card-photo relative order-1 md:order-2" style={{ aspectRatio: "4/3" }}>
          <img
            src={image || "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=1600&q=80"}
            alt="Group circle"
            className="w-full h-full object-cover absolute inset-0"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
